import BtnProgress from './component/BtnProgress';
import BtnCheck from './component/BtnCheck';
import Animation from './component/Animation';
import { Form } from './component/Form';
import FlashMessage from './component/FlashMessage';
import ToggleShow from './component/ToggleShow';
import Navbar from './component/Navbar';
import Anchor from './component/Anchor';
import CategoryList from './component/CategoryList';
import RangePriceInputs from './component/RangePriceInputs';
import ContentFilterButton from './component/ContentFilterButton';
import CustomSelect from './component/CustomSelect';
import DetailHeader from './component/DetailHeader';
import Sliders from './component/Sliders';
import FaqSection from './component/FaqSection';
import NetteForms from 'nette-forms';
import Filter from './component/Filter';
import CartForm from './component/CartForm';
import CustomCartSelect from './component/CustomCartSelect';
import Loader from './component/Loader';
import Cart from './component/Cart';
import CartNote from './component/CartNote';
import FixedBlock from './component/FixedBlock';
import Search from './component/Search';
import MicroModal from './component/MicroModal';
import OrderCartFormSync from './component/OrderCartFormSync';
import PackageSelect from './component/PackageSelect';
import ProductItemVideoHover from './component/ProductItemVideoHover';
import ContentSwitcher from './component/ContentSwitcher';
import FileUploadManagerCart from './component/FileUploadManagerCart';
import FsLightbox from './component/FsLightbox';
import NiceSelect from './component/NiceSelect';
import AvatarUpload from './component/AvatarUpload';
import ComponentInitializer from './utils/ComponentInitializer';
import Notification from './component/Notification';
import FooterAccordion from './component/FooterAccordion';
import PersonStockSearch from './component/PersonStockSearch';
import TextExpand from './component/TextExpand';
import OrdersTableFilter from './component/OrdersTableFilter';
import GtmTracking from './component/GtmTracking';
import MetaPixelTracking from './component/MetaPixelTracking';
import SmartFormIntegration from './component/SmartFormIntegration';
import Checkbox from './component/Checkbox';
import OrderPerson from './component/OrderPerson';
import ZasilkovnaWidget from './component/ZasilkovnaWidget';
import PaymentMethodSelect from './component/PaymentMethodSelect';

document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));
NetteForms.initOnLoad();
(<any>window).nette = NetteForms;

_naja.addEventListener('success', () => {
    Loader.hide();
});

window.addEventListener('DOMContentLoaded', () => {
    BtnProgress.init();
    BtnCheck.init();
    Animation.init();
    Form.init();
    FlashMessage.init();
    ToggleShow.init();
    Navbar.init();
    CategoryList.init();
    RangePriceInputs.init();
    ContentFilterButton.init();
    Anchor.init();
    CustomSelect.init();
    DetailHeader.init();
    Sliders.init();
    FaqSection.init();
    Filter.init();
    CartForm.init();
    Loader.init();
    CustomCartSelect.init();
    Cart.init();
    CartNote.init();
    Search.init();
    FixedBlock.init();
    MicroModal.init();
    ProductItemVideoHover.init();
    ContentSwitcher.init();
    FileUploadManagerCart.init();
    FsLightbox.init();
    NiceSelect.init();
    AvatarUpload.init();
    // Initialize OrderCartFormSync
    new OrderCartFormSync();
    PackageSelect.init();
    Notification.init();
    FooterAccordion.init();
    TextExpand.init();
    Checkbox.init();
    OrderPerson.init();
    PaymentMethodSelect.init();
    ZasilkovnaWidget.init();
    new PersonStockSearch();
    new OrdersTableFilter();
    new GtmTracking().init();
    new MetaPixelTracking().init();

    // Initialize SmartForm integration if on registration or order cart page
    if (document.querySelector('.smartform-instance-1')) {
        SmartFormIntegration.initialize('m35n1XhilE', 1);
    }
});

window.addEventListener('scroll', () => {
    Animation.init();
});
